// @flow

import React, { Component } from "react"
import styles from "./styles.css"
import ArrowIcon from "../ArrowIcon"

export default class Hidable extends Component {
  props: {
    title: string,
    titleNumber?: number,
    expanded?: boolean,
    onToggle?: () => any,
    children?: any,
    titleClassName?: string,
    titleStyle?: any,
  }

  componentWillReceiveProps = ( nextProps ) => {
    if ( nextProps.expanded !== this.props.expanded ) {
      this.setState( { expanded: nextProps.expanded } )
    }
  }

  state = {
    expanded: this.props.expanded,
  }

  onToggle = () => this.setState( state => ( { expanded: !state.expanded } ) )

  render () {
    const {
      titleStyle,
      titleClassName,
      onToggle: onToggleProps,
      children,
      title,
      titleNumber,
    } = this.props
    const { expanded } = this.state
    const onToggle = onToggleProps != null ? onToggleProps : this.onToggle

    const showNumber = ( titleNumber !== undefined )

    return (
      <div>
        <div
          className={styles.titleRow}
          onClick={onToggle}
          onKeyPress={onToggle}
          role="button"
          tabIndex="0"
        >
          <div className={styles.titleWrapper}>
            <div
              className={titleClassName || styles.title}
              style={titleStyle}
            >
              {title}
            </div>
            { showNumber ?
              <div className={styles.chip}>
                <span>{titleNumber}</span>
              </div> : <div/> }

          </div>
          <ArrowIcon invert={expanded} />
        </div>
        <div
          className={styles.content}
          style={{
            maxHeight: expanded ? undefined : "0px",
            overflow: expanded ? "visible" : "hidden",
          }}
        >
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hidable/index.jsx